import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPendingIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 20 20",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		"data-name": "Icon - Pending",
		transform: "translate(-132 -432)",
		children: [/* @__PURE__ */ _jsx("g", {
			"data-name": "Interface-Essential / Navigate / navigation-down-circle",
			transform: "translate(141.928 438.149) rotate(45)",
			children: /* @__PURE__ */ _jsx("g", {
				"data-name": "Group 742",
				children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
					"data-name": "Shape 3469",
					d: "M0,5.251,2.626,2.626l-4.65-4.65",
					fill: "none",
					stroke: "currentColor",
					strokeWidth: 1.5
				}) })
			})
		}), /* @__PURE__ */ _jsx("g", {
			"data-name": "Group 4414",
			transform: "translate(90 -980)",
			children: /* @__PURE__ */ _jsxs("g", {
				"data-name": "Ellipse 765",
				transform: "translate(42 1412)",
				fill: "none",
				stroke: "currentColor",
				strokeWidth: 1.5,
				children: [/* @__PURE__ */ _jsx("circle", {
					cx: 10,
					cy: 10,
					r: 10,
					stroke: "none"
				}), /* @__PURE__ */ _jsx("circle", {
					cx: 10,
					cy: 10,
					r: 9.25,
					fill: "none"
				})]
			})
		})]
	})
});
export { SvgPendingIcon as ReactComponent };
